import React, { useEffect, useState, useMemo } from "react";
import {
  Box,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
  Checkbox,
  tableCellClasses,
  Menu,
  MenuItem,
  Modal,
} from "@mui/material";
import { SearchIcon } from "assets";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { PrimaryButton } from "components/Buttons";
import Colors from "assets/Style/Colors";
import { FontFamily } from "assets";
import { ErrorToaster, SuccessToaster } from "components/Toaster";
import InputField from "components/Input";
import FinanceServices from "services/Finance";
import DatePicker from "components/DatePicker";
import ConfirmationDialog from "components/Dialog/ConfirmationDialog";
import {
  getFileSize,
  CommaSeparator,
} from "utils";
import { Add, Delete } from "@mui/icons-material";
import styled from "@emotion/styled";
import { useSelector } from "react-redux";
import Uploading from "components/Uploading";
import UploadFile from "components/UploadFile";
import { v4 as uuidv4 } from "uuid";
import { CleanTypes } from "utils";
import instance from "config/axios";
import routes from "services/System/routes";
import { useAuth } from "context/UseContext";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { getYearMonthDateFormate } from "utils";
import { createRoot } from "react-dom/client";
import JournalVoucherDetailInvoice from "components/erp_invoices/journalVoucher";
import SystemServices from "services/System";
import CloseIcon from '@mui/icons-material/Close';

// *For Table Style
const Row = styled(TableRow)(({ theme }) => ({
  border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    border: 0,
    textAlign: "center",
    whiteSpace: "nowrap",
    backgroundColor: Colors.primary,
    color: Colors.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    textAlign: "center",
    textWrap: "nowrap",

    ".MuiBox-root": {
      display: "flex",
      gap: "6px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.NunitoRegular,
      textWrap: "nowrap",
    },
    ".MuiButtonBase-root": {
      padding: "8px",
      width: "28px",
      height: "28px",
    },
  },
}));
// *For Upload File types
const allowFilesType = [
  "image/png",
  "image/jpg",
  "image/jpeg",
  "application/pdf",
];

function CreateJournalVoucherV2() {
  const navigate = useNavigate();
  const { user, userLogout } = useAuth();
  const { usdExchangeRate, cadExchangeRate } = useSelector(
    (state) => state.navigationReducer
  );

  const toAmount = (v) => {
    if (v === "" || v === null || v === undefined) return 0;
    const n = Number(String(v).replace(/,/g, ""));
    return Number.isFinite(n) ? n : 0;
  };


  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
    getValues,
  } = useForm();
  const {
    register: register2,
    handleSubmit: handleSubmit2,
    setValue: setValue2,
    resetField: resetField2,
  } = useForm();
  const { register: register3, handleSubmit: handleSubmit3 } = useForm();
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [loader, setLoader] = useState(false);
  const [vouchersTemplate, setVouchersTemplate] = useState([])


  const [openRateDialog, setOpenRateDialog] = useState(false);
  const [openRateModal, setOpenRateModal] = useState(false);

  // *For Payment Method
  const [paymentMethod, setPaymentMethod] = useState("bank");

  // *For Bank Account
  const [bankAccounts, setBankAccounts] = useState([]);
  const [selectedBankAccount, setSelectedBankAccount] = useState(null);

  // *For Cashier Account
  const [cashierAccounts, setCashierAccounts] = useState([]);
  const [selectedCashierAccount, setSelectedCashierAccount] = useState(null);

  // *For Vault Customer
  const [vaultCustomers, setVaultCustomers] = useState([]);
  const [selectedVaultCustomer, setSelectedVaultCustomer] = useState(null);

  // *For Customer Vault Accounts
  const [vaultAccounts, setVaultAccounts] = useState([]);
  const [selectedVaultAccount, setSelectedVaultAccount] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [selectedMajorCategory, setSelectedMajorCategory] = useState(null);


  // *For Handle Date
  const [vaultDate, setVaultDate] = useState(new Date());
  const [fromDate, setFromDate] = useState();

  console.log(fromDate, 'fromDate....')

  // *For Vault Unit
  const [accountList, setAccountList] = useState([]);

  // *For Currency
  const [exchangeRateAed, setExchangeRateAed] = useState();
  const [exchangeRateUsd, setExchangeRateUsd] = useState();


  // *For Uploaded Documents
  const [progress, setProgress] = useState(0);
  const [uploadedSize, setUploadedSize] = useState(0);
  const [documentDetail, setDocumentDetail] = useState([]);
  const [documentLink, setDocumentLink] = useState("");
  const [newExchangeRateUsd, setNewExchangeRateUsd] = useState(0);
  const [bankType, setBankType] = useState("guc");
  const [searchResults, setSearchResults] = useState([]);
  const [rowOpen, setRowOpen] = useState({});
  const [shippingBankAccounts, setShippingBankAccounts] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [filters, setFilters] = useState({});
  const [pageLimit, setPageLimit] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchData, setSearchData] = useState([]);
  const [path, setPath] = useState([]);
  const [selectedItems, setSelectedItems] = useState({});
  const [addedItemIds, setAddedItemIds] = useState([]);
  const [JournalData, setJournalData] = useState();
  const [journalVoucherList, setJournalVoucherList] = useState([]);
  const [parentAccounts, setParentAccounts] = useState([]);
  const [selectedParentAccount, setSelectedParentAccount] = useState(null);
  const [subCategories, setSubCategories] = useState([]);


  // *For Accounts
  const [accounts, setAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);

  // Added rows (persisted)
  const [addedRows, setAddedRows] = useState([]);
  // LS helpers
  const LS_KEY = "pv2_added_rows";

  const totalSelectedCount = useMemo(
    () => Object.keys(selectedItems).length,
    [selectedItems]
  );
  // const addedCount = useMemo(() => addedItemIds.length, [addedItemIds]);

  const toggleCheckbox = (id) => {
    setSelectedItems((prev) => {
      const newSelectedItems = { ...prev };
      if (newSelectedItems[id]) {
        delete newSelectedItems[id];
      } else {
        newSelectedItems[id] = true;
      }
      return newSelectedItems;
    });
  };


  const getSubCategories = async (id) => {
    try {
      let params = {
        category_id: id ?? "",
      };
      const { data } = await FinanceServices.getSubCategories(params);
      setSubCategories(data?.categories);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Get Account By SubCategory
  const getAccountBySubCategory = async (id) => {
    try {
      let params = {
        sub_category: id,
      };
      const { data } = await FinanceServices.getAccountBySubCategory(params);
      setParentAccounts(data?.accounts?.rows);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Get Account
  const getAccounts = async (search, accountId) => {
    try {
      let params = {
        page: 1,
        limit: 50,
        name: search,
        primary_account_id: accountId ?? selectedParentAccount?.id,
      };
      const { data } = await FinanceServices.getAccounts(params);

      // Remove duplicates based on name instead of account_code
      const uniqueAccounts = data?.accounts?.rows.filter(
        (account, index, self) =>
          index === self.findIndex((a) => a.name === account.name)
      );

      setAccounts(uniqueAccounts);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const addVoucher = async (formData) => {
    try {
      const voucherCopy = [...journalVoucherList];
      let obj = {
        account_id: selectedAccount
          ? selectedAccount?.id
          : selectedParentAccount?.id,
        coa_code: formData?.accountCode,
        coa_name:
          accounts.length > 0 ? formData?.account : formData?.parentAccount,
        debit: formData?.debit ? formData?.debit : 0,
        credit: formData?.credit ? formData?.credit : 0,
        description: formData?.description,
        currency: selectedAccount?.currency,
      };
      voucherCopy.push(obj);
      setJournalVoucherList(voucherCopy);
      reset();
      setSelectedMajorCategory(null);
      setSelectedSubCategory(null);
      setSelectedParentAccount(null);
      setSelectedAccount(null);
      setAccounts();
      setValue(
        "Journal",
        JournalData?.vouchers?.rows.length > 0
          ? "JV-" + (parseFloat(JournalData?.vouchers?.rows[0].id) + 1)
          : "JV-" + 1
      );
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Delete Journal Voucher
  const deleteJournalVoucher = async (index) => {
    setLoading(true);
    try {
      const voucherCopy = [...journalVoucherList];
      voucherCopy.splice(index, 1);
      setJournalVoucherList(voucherCopy);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoading(false);
    }
  };

  const handleFromDate = (newDate) => {
    try {
      // eslint-disable-next-line eqeqeq
      if (newDate == "Invalid Date") {
        setFromDate("invalid");
        return;
      }
      setFromDate(new Date(newDate));
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const toggleRow = (id) => setRowOpen((p) => ({ ...p, [id]: !p[id] }));

  useEffect(() => {
    if (totalSelectedCount === 0) {
      setSearchData([]);
      resetField2("search");
    }
  }, [selectedItems]);

  //   const handleAddFromSearch = (item) => {
  //     const id = item.id;

  //     const exRate = item?.currency === "aed" ? exchangeRateAed : exchangeRateUsd;

  //     if (!selectedItems[id]) {
  //       return ErrorToaster("Please select the checkbox first.");
  //     }

  //     const fullPath = [
  //       item?.cat?.name,
  //       item?.sub_cat?.name,
  //       item?.primary?.name,
  //       item?.name,
  //     ]
  //       .filter(Boolean)
  //       .join(" → ");

  //     const exRatee = item?.currency === "aed" ? 1 : 3.675;

  //     const generateRowKey = () => {
  //   const min = 10000; // Minimum 5 digits
  //   const max = 999999; // Maximum 6 digits
  //   return Math.floor(Math.random() * (max - min + 1)) + min; // Generates a random number within the range
  // };

  //     const row = {
  //       row_key: generateRowKey(),
  //       id,
  //       parent_id: item?.primary_account_id,
  //       currency: item?.currency,
  //       full_path: fullPath,
  //       account_code: item?.account_code || "",
  //       description: "",
  //       credit: 0,
  //       debit: 0,
  //     };

  //     setAddedRows((prev) => {
  //       const count = prev.filter((r) => r.id === id).length;

  //       if (count >= 5) {
  //         ErrorToaster("You can add this item only 5 times.");
  //         return prev;
  //       }

  //       return [...prev, row];
  //     });

  //     setSelectedItems((prev) => {
  //       const newSelectedItems = { ...prev };
  //       delete newSelectedItems[id];
  //       return newSelectedItems;
  //     });

  //     setAddedItemIds((prev) => [...prev, id]);

  //     SuccessToaster("Added.");

  //     if (totalSelectedCount === 0 || Object.keys(selectedItems).length === 0) {
  //       setSearchData([]);
  //       resetField2("search");
  //     }
  //   };

  const generateRowKey = () => {
    const min = 10000; // Minimum 5 digits
    const max = 999999; // Maximum 6 digits
    return Math.floor(Math.random() * (max - min + 1)) + min; // Generates a random number within the range
  };
  const handleAddFromSearch = (item) => {
    const id = item.id;
    const rowKey = item?.row_key;

    const rowExists = addedRows.some((row) => row.row_key === rowKey);
    if (rowExists) {
      return;
    }


    const exRate = item?.currency === "aed" ? exchangeRateAed : exchangeRateUsd;

    if (!selectedItems[id]) {
      return ErrorToaster("Please select the checkbox first.");
    }

    const fullPath = [
      item?.cat?.name,
      item?.sub_cat?.name,
      item?.primary?.name,
      item?.name,
    ]
      .filter(Boolean)
      .join(" → ");

    const exRatee = item?.currency === "aed" ? 1 : 3.675;

    const row = {
      row_key: generateRowKey(),
      id,
      parent_id: item?.primary_account_id,
      currency: item?.currency,
      full_path: fullPath,
      account_code: item?.account_code || "",
      description: "",
      credit: 0,
      debit: 0,
    };

    const count = addedRows.filter((r) => r.id === id).length;

    if (count >= 5) {
      ErrorToaster("You can add this item only 5 times.");
      return;
    }

    setAddedRows((prev) => {
      const updatedRows = [...prev, row];
      return updatedRows;
    });

    setSelectedItems((prev) => {
      const newSelectedItems = { ...prev };
      delete newSelectedItems[id];
      return newSelectedItems;
    });

    // setAddedItemIds((prev) => {
    //   const updatedIds = [...prev, id];
    //   console.log("After add - addedItemIds:", updatedIds);
    //   return updatedIds;
    // });

    SuccessToaster("Added.");

    if (totalSelectedCount === 0 || Object.keys(selectedItems).length === 0) {
      setSearchData([]);
      resetField2("search");
    }
  };


  const handleResetSearch = () => {
    setSearchData([]);
    setRowOpen({});
    resetField2("search");
  };
  // const removeAddedRow = (row_key) => {
  //   setAddedRows((prev) => prev.filter((row) => row?.row_key !== row_key));
  // };

  const removeAddedRow = (row_key) => {

    setAddedRows((prevRows) => {
      const updatedRows = prevRows.filter((row) => row?.row_key !== row_key);
      return updatedRows;
    });

  };


  const updateAddedRow = (row_key, patch) => {
    setAddedRows((prevRows) =>
      prevRows.map((r) =>
        r.row_key === row_key
          ? { ...r, ...patch }
          : r
      )
    );
  };


  // *For Handle Date
  const handleVaultDate = (newDate) => {
    try {
      // eslint-disable-next-line eqeqeq
      if (newDate == "Invalid Date") {
        setVaultDate("invalid");
        return;
      }
      setVaultDate(new Date(newDate));
    } catch (error) {
      ErrorToaster(error);
    }
  };


  const getJournalVouchers = async () => {
    try {
      let params = {
        page: 1,
        limit: 1,
      };

      const { data } = await FinanceServices.getJournalVouchers(params);
      setJournalData(data);
      setValue(
        "Journal",
        data?.vouchers?.rows.length > 0
          ? "JV-" + (parseFloat(data?.vouchers?.rows[0].id) + 1)
          : "JV-" + 1
      );
    } catch (error) {
      ErrorToaster(error);
    }
  };


  const getAllDataOfAccounts = async (page, limit, filter) => {
    setLoadings(true);
    const Page = page ? page : currentPage;
    const Limit = limit ? limit : pageLimit;
    const Filter = { ...filters, ...filter };
    setCurrentPage(Page);
    setPageLimit(Limit);
    setFilters(Filter);

    try {
      let params = {
        page: Page,
        limit: Limit,
        excludeL2: true,
      };
      params = { ...params, ...Filter };

      const { data } = await FinanceServices.getAllAccountsData(params);
      setSearchData(data?.accounts);
    } catch (error) {
      setLoadings(false);
      ErrorToaster(error);
    }
  };

  const AED_PER_USD = 3.675;

  const totals = React.useMemo(() => {
    let totalAEDCredit = 0;
    let totalUSDCredit = 0;
    let totalAEDDebit = 0;
    let totalUSDDebit = 0;


    for (const r of addedRows || []) {
      const amount = Number(r?.credit || 0);
      if (!amount || isNaN(amount)) continue;
      totalAEDCredit += amount;
      totalUSDCredit += amount / AED_PER_USD;
    }

    for (const r of addedRows || []) {
      const amount = Number(r?.debit || 0);
      if (!amount || isNaN(amount)) continue;
      totalAEDDebit += amount;
      totalUSDDebit += amount / AED_PER_USD;
    }

    return {
      creditaed: Number(totalAEDCredit.toFixed(2)),
      creditusd: Number(totalUSDCredit.toFixed(2)),
      debitaed: Number(totalAEDDebit.toFixed(2)),
      debitusd: Number(totalUSDDebit.toFixed(2)),
    };
  }, [addedRows]);

  const accountTotals = React.useMemo(() => {
    let totalAED = 0;
    let totalUSD = 0;

    for (const r of accountList || []) {
      const amount = Number(r?.fcy_amount ?? 0);
      if (!amount || isNaN(amount)) continue;
      totalAED += amount;
      totalUSD += amount / AED_PER_USD;

    }

    return {
      aed: Number(totalAED.toFixed(2)),
      usd: Number(totalUSD.toFixed(2)),
    };
  }, [accountList]);

  const hasEntries = addedRows.length > 0; 

  const isSubmitDisabled = !(
    (totals.creditaed === totals.debitaed)
  );

  const stripHtml = (input = "") => {
    if (!input) return "";
    let out = input.replace(/<[^>]*>/g, "");
    out = out.replace(/on\w+="[^"]*"/gi, "");
    out = out.replace(/\r?\n+/g, " ").trim();
    return out;
  };

  const sqlBadPatterns = [
    /--/i,
    /;/,
    /\/\*|\*\//,
    /\bunion\s+select\b/i,
    /\bdrop\s+(table|database)\b/i,
    /\btruncate\s+table\b/i,
    /\binsert\s+into\b/i,
    /\bupdate\s+.*\s+set\b/i,
    /\bdelete\s+from\b/i,
    /\bxp_[_a-z]+\b/i,
    /\bsys\.[_a-z]+\b/i,
    /\bor\s+1\s*=\s*1\b/i,
  ];

  const MAX_DESC_LEN = 500;

  const sanitizeDescription = (input) => {
    const noHtml = stripHtml(input ?? "");
    const clipped = noHtml.slice(0, MAX_DESC_LEN);
    return clipped;
  };

  const hasSqlInjectionPattern = (input = "") =>
    sqlBadPatterns.some((re) => re.test(input));

  const validateSafeDescription = (value) => {
    const raw = value ?? "";
    const cleaned = sanitizeDescription(raw);
    if (!cleaned) return "Please enter a description.";
    if (hasSqlInjectionPattern(cleaned)) {
      return "Your description contains disallowed patterns.";
    }
    return true;
  };

  useEffect(() => {
    if (searchData) {
      const paths = searchData.map((item) => {
        return [
          item?.cat?.name,
          item?.sub_cat?.name,
          item?.primary?.name,
          item?.name,
        ]
          .filter(Boolean)
          .join(" → ");
      });

      setPath(paths);
    }
  }, [searchData]);

  // *For Upload Document
  const handleUploadDocument = async (e) => {
    try {
      e.preventDefault();
      const file = e.target.files[0];
      let arr = [
        {
          id: uuidv4(),
          name: file?.name,
          file: "",
          type: file?.type.split("/")[1],
          size: getFileSize(file.size),
          isUpload: false,
        },
      ];
      if (allowFilesType.includes(file.type)) {
        setDocumentDetail(arr);
        handleUpload(file, arr);
      } else {
        ErrorToaster(`Only ${CleanTypes(allowFilesType)} formats is supported`);
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };


  const createJournalVoucher = async (formData) => {
    setLoading(true);
    try {
      const entries = addedRows.map((item) => {
        const debitAed = toAmount(item.debit);
        const creditAed = toAmount(item.credit);
        const debit_cur =
          item.currency === "aed"
            ? ""
            : item.currency === "usd"
              ? item.debit * usdExchangeRate
              : item.debit * cadExchangeRate;
        const credit_cur =
          item.currency === "aed"
            ? ""
            : item.currency === "usd"
              ? item.credit * usdExchangeRate
              : item.credit * cadExchangeRate;
        return {
          account_id: item.account_id ? item.account_id : item.id,
          debit: debitAed.toFixed(2),
          debit_cur: debit_cur ? debit_cur : 0,
          credit: creditAed.toFixed(2),
          credit_cur: credit_cur ? credit_cur : 0,
          currency: item.currency,
          description: item.description,
          full_path: item?.full_path,
          row_key: item?.row_key,
        };
      });
      let obj = {
        total: parseFloat(totals.debitaed)?.toFixed(2),
        notes: getValues("note"),
        entries: entries,
        created_at: getYearMonthDateFormate(fromDate),
        document_link: documentLink,
        is_template: false,
        new_voucher: true,
      };

      if (selectedTemplate) {
        obj.voucher_id = selectedTemplate.id;
        obj.from_template = true;
      }
      // else {
      //   obj.id = formData?.id; 
      // }

      const result = await FinanceServices.createJournalVoucher(obj);

      if (result?.status === true && result?.responseCode === 200) {

        const voucher_id = result?.data?.id;

        const params = { voucher_id };

        // 1) Fetch full invoice list
        const { data } = await FinanceServices.getJournalVoucherDetail(params);

        if (!data) {
          console.log("No record found to upload");
          return;
        }

        // 2) Generate PDFs
        const uploadFiles = [];

        const file = await new Promise((resolve, reject) => {
          try {
            const container = document.createElement("div");
            container.style.position = "absolute";
            container.style.top = "-99999px";
            container.style.left = "-99999px";
            container.style.width = "1200px";
            document.body.appendChild(container);

            const root = createRoot(container);

            const handleDone = (pdfBlob) => {
              setTimeout(() => {
                try {
                  root.unmount();
                  container.remove();
                } catch { }
                resolve(pdfBlob);
              }, 200);
            };

            root.render(
              <JournalVoucherDetailInvoice
                voucherDetail={data?.voucher}
                onDone={handleDone}
              />
            );
          } catch (err) {
            console.error("❌ PDF Generation Error", err);
            reject(err);
          }
        });

        const pdfFile =
          file instanceof Blob
            ? new File([file], `journalVoucher-JV-${voucher_id}.pdf`, {
              type: "application/pdf",
            })
            : null;

        uploadFiles.push({
          voucher_id: voucher_id,
          file: pdfFile,
        });

        // 3) Upload PDFs
        const formData = new FormData();
        formData.append("invoice_type", "journalVoucher");

        uploadFiles.forEach((file, index) => {
          formData.append(`journal_voucher[${index}][voucher_id]`, voucher_id);
          formData.append(`journal_voucher[${index}][file]`, file.file);
        });

        await SystemServices.uploadERPInvoices(formData);
        SuccessToaster(result.message);
        setLoading(false);
        navigate("/journal-vouchers");
        window.location.reload();
      }
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoading(false);
    }
  };


  const createJournalVoucherTemplate = async (templateName) => {
    setLoadings(true);
    console.log(templateName, 'templateName in api')
    try {
      const entries = addedRows.map((item) => {
        const debit_cur =
          item.currency === "aed"
            ? ""
            : item.currency === "usd"
              ? item.debit * usdExchangeRate
              : item.debit * cadExchangeRate;
        const credit_cur =
          item.currency === "aed"
            ? ""
            : item.currency === "usd"
              ? item.credit * usdExchangeRate
              : item.credit * cadExchangeRate;
        return {
          account_id: item?.account_id ? item?.account_id : item?.id,
          debit: parseFloat(item.debit)?.toFixed(2),
          debit_cur: debit_cur ? debit_cur : 0,
          credit: parseFloat(item.credit)?.toFixed(2),
          credit_cur: credit_cur ? credit_cur : 0,
          currency: item?.currency,
          description: item?.description,
          full_path: item?.full_path,
          row_key: item?.row_key,
        };
      });
      let obj = {
        total: parseFloat(totals.debitaed)?.toFixed(2),
        notes: getValues("note"),
        entries: entries,
        created_at: getYearMonthDateFormate(fromDate),
        document_link: documentLink,
        is_template: true,
        template_name: templateName,
      };

      if (selectedTemplate) {
        obj.voucher_id = selectedTemplate.id;
      }
      // else {
      //   obj.id = formData?.id; 
      // }

      const result = await FinanceServices.createJournalVoucher(obj);

      if (result?.status === true && result?.responseCode === 200) {

        const voucher_id = result?.data?.id;

        const params = { voucher_id };

        // 1) Fetch full invoice list
        const { data } = await FinanceServices.getJournalVoucherDetail(params);

        if (!data) {
          console.log("No record found to upload");
          return;
        }

        // 2) Generate PDFs
        const uploadFiles = [];

        const file = await new Promise((resolve, reject) => {
          try {
            const container = document.createElement("div");
            container.style.position = "absolute";
            container.style.top = "-99999px";
            container.style.left = "-99999px";
            container.style.width = "1200px";
            document.body.appendChild(container);

            const root = createRoot(container);

            const handleDone = (pdfBlob) => {
              setTimeout(() => {
                try {
                  root.unmount();
                  container.remove();
                } catch { }
                resolve(pdfBlob);
              }, 200);
            };

            root.render(
              <JournalVoucherDetailInvoice
                voucherDetail={data?.voucher}
                onDone={handleDone}
              />
            );
          } catch (err) {
            console.error("❌ PDF Generation Error", err);
            reject(err);
          }
        });

        const pdfFile =
          file instanceof Blob
            ? new File([file], `journalVoucher-JV-${voucher_id}.pdf`, {
              type: "application/pdf",
            })
            : null;

        uploadFiles.push({
          voucher_id: voucher_id,
          file: pdfFile,
        });

        // 3) Upload PDFs
        const formData = new FormData();
        formData.append("invoice_type", "journalVoucher");

        uploadFiles.forEach((file, index) => {
          formData.append(`journal_voucher[${index}][voucher_id]`, voucher_id);
          formData.append(`journal_voucher[${index}][file]`, file.file);
        });

        await SystemServices.uploadERPInvoices(formData);
        SuccessToaster(result.message);
        setLoading(false);
        setAddedRows([])
        getJournalVouchersTemplate();
        // navigate("/journal-vouchers");
      }
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoadings(false);
    }
  };


  const getJournalVouchersTemplate = async () => {
    try {
      // const Page = page ? page : currentPage;
      // const Limit = limit ? limit : pageLimit;
      // const Filter = { ...filters, ...filter };
      // setCurrentPage(Page);
      // setPageLimit(Limit);
      // setFilters(Filter);
      // let params = {
      //   page: Page,
      //   limit: Limit,
      // };
      // params = { ...params, ...Filter };
      const { data } = await FinanceServices.getJournalVoucherTemplte();
      setTemplates(data?.vouchers?.rows || []);
      // setVouchersTemplate(data);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoader(false);
    }
  };

  const handleUpload = async (file, docs) => {
    setProgress(0);
    try {
      const formData = new FormData();
      formData.append("document", file);
      const { data } = await instance.post(routes.uploadDocuments, formData, {
        onUploadProgress: (progressEvent) => {
          const uploadedBytes = progressEvent.loaded;
          const percentCompleted = Math.round(
            (uploadedBytes * 100) / progressEvent.total
          );

          setProgress(percentCompleted);
          setUploadedSize(getFileSize(uploadedBytes));
        },
      });
      if (data) {
        docs[0].isUpload = true;
        docs[0].file = data?.data?.nations;
        setDocumentDetail(docs);
        setDocumentLink(data?.data?.nations);
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };
  // *For Remove Uploaded Document
  const removeDoc = () => {
    try {
      setDocumentDetail([]);
      setDocumentLink("");
      setValue("scanned", "");
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleFilter = async (data) => {
    const q = (data?.search ?? "").trim();
    if (!q) {
      setSearchData([]);
      setLoadings(false);
      return;
    }

    setLoadings(true);
    if (isSearching) return;

    setIsSearching(true);
    try {
      await getAllDataOfAccounts(1, "", { search: q });
    } catch (err) {
      console.error("Search failed:", err);
    } finally {
      setIsSearching(false);
      setLoadings(false);
    }
  };

  const [templates, setTemplates] = useState([]);
  console.log(templates, 'templates')
  const [anchorEl, setAnchorEl] = useState(null);
  const [openTemplatePopup, setOpenTemplatePopup] = useState(false);
  const [templateName, setTemplateName] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState(null); // Track selected template
  const [confirmationDialog, setConfirmationDialog] = useState(false);
  const [voucherId, setVoucherId] = useState();


  console.log(templateName, 'name')
  // const [rows, setRows] = useState(initialTemplates[0].rows);
  const handleOpenTemplatePopup = () => {
    setOpenTemplatePopup(true);
  };

  const handleCloseTemplatePopup = () => {
    setOpenTemplatePopup(false);
  };

  const open = Boolean(anchorEl);

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleSelectTemplate = (template) => {
      console.log("template entries:", template.entries);
    const templateEntries = template.entries.map((entry) => ({
      
      ...entry,
debit: Number(entry?.debit) >= 0 ? Number(entry?.debit) : 0,
credit: Number(entry?.credit) >= 0 ? Number(entry?.credit) : 0,
    }));
    setSelectedTemplate(template);
    setAddedRows(templateEntries);
    setValue("note", template?.notes || "");
    handleFromDate(template?.c_date);
    setTemplateName(template?.template_name);

    handleCloseMenu();
  };


  const handleDeleteTemplate = async () => {
    try {
      const { message } = await FinanceServices.deleteJournalVoucherTemplate({ voucher_id: voucherId });
      SuccessToaster(message);
      getJournalVouchersTemplate();
      setConfirmationDialog(false);
    } catch (error) {
      ErrorToaster(error);
    }
    // event.stopPropagation();
    // setTemplates((prev) => prev.filter((t) => t.id !== templateId));
  };


  const handleDeleteRow = (rowKey) => {
    setAddedRows((prevRows) => prevRows.filter((row) => row.row_key !== rowKey));
  };

  const handleSaveTemplate = async () => {
    if (!templateName) {
      return ErrorToaster("Please enter a template name.");
    }

    // Proceed to create the journal voucher template with the template name
    await createJournalVoucherTemplate(templateName);

    // Close the popup after saving
    handleCloseTemplatePopup();
  };



  useEffect(() => {
    setFromDate(new Date());
    getJournalVouchers();
    getJournalVouchersTemplate();
  }, []);


  return (
    <Box
      sx={{
        m: 4,
        p: 5,
        bgcolor: Colors.white,
        borderRadius: 3,
        boxShadow: "0px 8px 18px 0px #9B9B9B1A",
      }}
    >

      <ConfirmationDialog
        open={confirmationDialog}
        onClose={() => setConfirmationDialog(false)}
        message={"Are you sure you want to delete this?"}
        action={() => handleDeleteTemplate()}
      />

      <Modal
        open={openTemplatePopup}
        onClose={handleCloseTemplatePopup}
        aria-labelledby="template-name-popup"
        aria-describedby="enter-template-name"
      >
        <Box
          sx={{
            width: 400,
            bgcolor: "white",
            borderRadius: 2,
            padding: 3,
            boxShadow: 24,
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography variant="h6" gutterBottom>
              Enter Template Name
            </Typography>

            {/* Close Icon Button */}
            <IconButton onClick={handleCloseTemplatePopup} sx={{ color: Colors.charcoalGrey }}>
              <CloseIcon />
            </IconButton>
          </Box>

          <InputField
            fullWidth
            variant="outlined"
            label="Template Name"
            value={templateName}
            onChange={(e) => setTemplateName(e.target.value)}
          />
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <PrimaryButton title="Save" onClick={handleSaveTemplate} buttonStyle={{ minWidth: "120px" }} />
          </Box>
        </Box>
      </Modal>

      <Menu anchorEl={anchorEl} open={open} onClose={handleCloseMenu}>
        {templates.length === 0 && (
          <MenuItem disabled>No templates saved</MenuItem>
        )}

        {templates.map((template) => (
          <MenuItem
            key={template.id}
            onClick={() => handleSelectTemplate(template)}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              width="100%"
            >
              <Typography variant="body2">{template?.template_name} - journal</Typography>

              <IconButton
                size="small"
                edge="end"
                onClick={() => {

                  setConfirmationDialog(true);

                  setVoucherId(template?.id);
                }}
              >
                <DeleteOutlineIcon fontSize="small" />
              </IconButton>
            </Box>
          </MenuItem>
        ))}
      </Menu>

      <Box component="form" onSubmit={handleSubmit(createJournalVoucher)}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 4,
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  color: Colors.charcoalGrey,
                  fontFamily: FontFamily.NunitoRegular,
                }}
              >
                Create Journal Voucher V2
              </Typography>

              <PrimaryButton
                title="Load Template"
                type="button"
                endIcon={<KeyboardArrowDownIcon sx={{ fontSize: '22px' }} />}
                onClick={handleOpenMenu}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={2.6} display="flex">
            <Typography color="black" mt={2} mr={1} fontSize="18px">
              Date
            </Typography>
            <DatePicker
              disableFuture={true}
              size="small"
              // label={"Journal Date"}
              value={fromDate}
              onChange={(date) => handleFromDate(date)}
            />
          </Grid>
          <Grid item xs={12} sm={2.6}>
            <InputField
              size={"small"}
              disabled={true}
              // label={" Journal No."}
              placeholder={"Journal No."}
              register={register("Journal")}
            />
          </Grid>

          <Grid item xs={12} sm={5.2}>
            <InputField
              size={"small"}
              // label={'Search'}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              placeholder={"Search"}
              register={register2("search", {
                onChange: (e) => handleFilter({ search: e.target.value }),
              })}

            />
          </Grid>

          {searchData?.length > 0 && (
            <>
              <Grid item xs={12}>
                <Box
                  sx={{
                    mt: 0.5,
                    border: "1px solid #E5E7EB",
                    borderRadius: 2,
                    overflow: "hidden",
                  }}
                >
                  {searchData.map((item, index) => {
                    const open = !!rowOpen[item.id];
                    const pathForItem = path[index];
                    const isChecked = selectedItems[item.id] || false;
                    return (
                      <Box
                        key={item?.id}
                        sx={{
                          display: "grid",
                          alignItems: "center",
                          gridTemplateColumns: {
                            xs: isChecked
                              ? "100px 1fr 0.5fr 0.9fr 0.5fr"
                              : "auto 1fr",
                            sm: isChecked
                              ? "100px 1.3fr 0.7fr 1fr 0.5fr"
                              : "auto 1fr",
                            md: isChecked
                              ? "100px 1.4fr 0.7fr 1fr 0.5fr"
                              : "auto 1fr",
                          },

                          columnGap: { xs: 1, sm: 1, md: 1 },
                          px: { xs: 0.5, sm: 1 },
                          py: 1,
                          borderBottom: "1px solid #F1F5F9",
                          "&:last-child": { borderBottom: 0 },
                        }}
                      >
                        <FormControlLabel
                          sx={{ m: 0 }}
                          control={
                            <Checkbox
                              checked={isChecked}
                              onChange={() => toggleCheckbox(item.id)}
                              sx={{ p: 0.5 }}
                            />
                          }
                          label=""
                        />

                        <Tooltip title={pathForItem} arrow>
                          <Typography
                            sx={{
                              minWidth: 0,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              fontSize: "12px",
                            }}
                          >
                            {pathForItem}
                          </Typography>
                        </Tooltip>

                        <Box
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          {isChecked && (
                            <IconButton
                              size="small"
                              onClick={() => handleAddFromSearch(item)}
                              sx={{
                                bgcolor: Colors.primary,
                                color: Colors.white,
                                "&:hover": {
                                  bgcolor: Colors.primary,
                                  color: Colors.white,
                                },
                              }}
                            >
                              <Add />
                            </IconButton>
                          )}
                        </Box>
                      </Box>
                    );
                  })}
                </Box>
              </Grid>
            </>
          )}

          {addedRows.length > 0 && (
            <>
              <Grid item xs={12}>
                <Box
                  sx={{
                    mt: 2,
                    border: "1px solid #E5E7EB",
                    borderRadius: 2,
                    overflow: "hidden",
                  }}
                >
                  {/* header */}
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "44% 8% 8% 30% 10%",
                      gap: 2,
                      px: 1.5,
                      py: 1,
                      bgcolor: Colors.primary,
                      color: "#ffff",
                      borderBottom: "1px solid #EEF2F7",
                      fontWeight: 700,
                      fontSize: 12,
                    }}
                  >
                    <Typography>Full Path</Typography>
                    <Typography>Debit(AED)</Typography>
                    <Typography>Credit(AED)</Typography>
                    <Typography>Description</Typography>
                    <Typography>Action</Typography>
                    <Typography />
                  </Box>

                  {addedRows.map((r) => (
                    <Box
                      key={r?.row_key}
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "44% 8% 8% 30% 10%",
                        gap: 2,
                        px: 1.5,
                        py: 1,
                        borderBottom: "1px solid #F1F5F9",
                        "&:last-child": { borderBottom: 0 },
                      }}
                    >
                      <Tooltip title={r.full_path} arrow>
                        <Typography
                          sx={{
                            minWidth: 0,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            fontSize: "12px",
                            mt: 2,
                          }}
                        >
                          {r.full_path}
                        </Typography>
                      </Tooltip>

                      <Typography sx={{ textAlign: "right", fontSize: "14px" }}>
                        <InputField
                          size="small"
                          placeholder="0.00"
                          value={r.debit ?? ""}
                          fullWidth
                          disabled={toAmount(r.credit) > 0}
                          register={register(`searchRows.${r.row_key}.debit`, {
                            pattern: /^[0-9]*\.?[0-9]{0,2}$/,
                            onChange: (e) => {
                              let v = e.target.value;

                              v = v.replace(/,/g, "");

                              if (v !== "" && Number(v) <= 0) {
                                ErrorToaster("Amount must be greater than 0.");
                                return;
                              }

                              if (v === "" || /^[0-9]*\.?[0-9]{0,2}$/.test(v)) {
                                updateAddedRow(r.row_key, { debit: v });
                              }
                            }
                          })}
                        />
                      </Typography>

                      <Typography sx={{ textAlign: "right", fontSize: "14px" }}>
                        <InputField
                          size="small"
                          placeholder="0.00"
                          value={r.credit ?? ""}
                          fullWidth
                          disabled={toAmount(r.debit) > 0}
                          register={register(`searchRows.${r.row_key}.credit`, {
                            pattern: /^[0-9]*\.?[0-9]{0,2}$/,
                            onChange: (e) => {
                              let v = e.target.value;

                              v = v.replace(/,/g, "");

                              if (v !== "" && Number(v) <= 0) {
                                ErrorToaster("Amount must be greater than 0.");
                                return;
                              }

                              if (v === "" || /^[0-9]*\.?[0-9]{0,2}$/.test(v)) {
                                updateAddedRow(r.row_key, { credit: v });
                              }
                            }
                          })}
                        />
                      </Typography>

                      <Tooltip title={r.description} arrow>
                        <Typography
                          sx={{
                            minWidth: 0,
                            whiteSpace: "normal",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            fontSize: "14px",
                          }}
                        >
                          <InputField
                            size="small"
                            placeholder="Description"
                            fullWidth
                            multiline
                            value={r.description ?? ""}
                            onChange={(e) => {
                              updateAddedRow(r.row_key, {
                                description: e.target.value,
                              });
                            }}
                            onBlur={(e) => {
                              const cleaned = sanitizeDescription(
                                e.target.value
                              );
                              updateAddedRow(r.row_key, {
                                description: cleaned,
                              });
                            }}

                          />
                        </Typography>
                      </Tooltip>

                      <Box sx={{ mt: 2 }}>
                        <IconButton
                          size="small"
                          onClick={() => removeAddedRow(r?.row_key)}
                        >
                          <Delete
                            sx={{
                              color: Colors.danger,
                              height: "20px !important",
                            }}
                          />
                        </IconButton>
                      </Box>
                    </Box>
                  ))}
                </Box>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "44% 10% 25%",
                    gap: 2,
                    px: 1.5,
                    py: 1,
                    borderBottom: "1px solid #EEF2F7",
                    fontWeight: 700,
                    fontSize: 12,
                  }}
                >
                  <Typography>Total</Typography>
                  <Typography>
                    {CommaSeparator((totals.debitaed || 0).toFixed(2))} AED
                  </Typography>
                  <Typography>
                    {CommaSeparator((totals.creditaed || 0).toFixed(2))} AED
                  </Typography>
                </Box>
              </Grid>
            </>
          )}

          <Grid item xs={12} sm={3}>
            <InputField
              label={"Note"}
              placeholder={"Note"}
              register={register("note")}
            />
          </Grid>


          <Grid item xs={12} sm={4}>
            <Typography
              variant="body1"
              sx={{ color: Colors.charcoalGrey, mb: 1 }}
            >
              Attach File
            </Typography>
            <UploadFile
              custom={true}
              style={{
                backgroundColor: "#e7efeb",
                width: "100%",
                height: "40px",
                display: "flex",
                justifyContent: "space-between",
                padding: "20px",
                border: "1px dashed #aeb1b0",
                borderRadius: "10px",
              }}
              error={errors?.scanned?.message}
              register={register("scanned", {
                onChange: (e) => handleUploadDocument(e),
              })}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            {documentDetail.length > 0 && (
              <Typography
                variant="body1"
                sx={{ color: Colors.charcoalGrey, mb: 1 }}
              >
                Uploaded Files
              </Typography>
            )}
            <Box sx={{ maxHeight: 300, overflow: "auto", pr: 1 }}>
              {documentDetail?.map((item, index) => (
                <Uploading
                  key={index}
                  data={item}
                  uploadedSize={uploadedSize}
                  progress={progress}
                  removeDoc={() => removeDoc()}
                />
              ))}
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
              }}
            >

              <PrimaryButton
                title={selectedTemplate ? "Update Template" : "Save As Template"}
                // title="Save As Template"
                type="button"
                onClick={handleOpenTemplatePopup}
                // onClick={handleOpenTemplatePopup}
                // onClick={createJournalVoucherTemplate}
                loading={loadings}
                disabled={addedRows.length === 0}
              />

              <PrimaryButton
                title="Submit"
                type="submit"
                loading={loading}
                disabled={isSubmitDisabled || !hasEntries}
              />
            </Box>
          </Grid>

        </Grid>
      </Box>
    </Box>
  );
}

export default CreateJournalVoucherV2;
